import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferAreaSelectQuery, OfferAreaSelectVo } from './type';

/**
 * game service offer上传/修改时查询当前spu下的平台区域服务器，点击一级查子集
  GET /product/offerManage/getGameServcieAreaInfo
  接口ID：263628565
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628565
 */
export const getOfferAreaList = (params: OfferAreaSelectQuery): AxiosPromise<OfferAreaSelectVo> => {
  return request({
    url: '/product/offerManage/getGameServcieAreaInfo',
    method: 'get',
    params
  });
};
